import { ReactNode } from "react";

type IProps = {
  children: ReactNode;
  className?: string;
};

function MainLayout({ children, className = "" }: IProps) {
  return <main className={`${className}`}>{children}</main>;
}

export default MainLayout;
